import React from 'react';
import PropTypes from 'prop-types';
import { PayloadStates } from '@lore/utils';
import DialogTemplate from '../../dialogs_common/DialogTemplate';
import Loader from '../../components/Loader';
import Event from './Event';
import CloseDialogButton from '../../dialogs_common/CloseDialogButton';

EventInviteDialog.propTypes = {
  event: PropTypes.object.isRequired
};

export default function EventInviteDialog(props) {
  const { event } = props;

  if (event.state === PayloadStates.FETCHING) {
    return (
      <DialogTemplate>
        <Loader />
      </DialogTemplate>
    );
  }

  return (
    <DialogTemplate className="w-full max-w-screen-lg">
      <CloseDialogButton onClick={props.onClose} />
      <Event
        event={event}
        onClose={props.onClose}
      />
    </DialogTemplate>
  );
};
